import React, { useCallback } from 'react'
import Popup from '../Popup'
import { ELanguage } from '../Utils/constants'
import { translations, TTranslationKey } from './translations'
import StarBurstIcon from '../Images/StarBurstIcon'
import { AIBeforeApplyContainer, AIBeforeApplyTypo, ImageWrapper, ListWrapper, CTAWrapper } from './AIBeforeApply.css'
import Typography from '../Typography'
import { Row, Col } from '../LayoutSystem'
import Button from '../Button'
import ButtonAI from '../ButtonAI'

interface IAIBeforeApplyProps {
    langCode: ELanguage
    imageUrl: string
    showState: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
    onContinueApply: () => void
    onViewAnalysis: () => void
}

const AIBeforeApply = (props: IAIBeforeApplyProps) => {
    const { imageUrl, langCode, onContinueApply, onViewAnalysis } = props
    const [isShow, setIsShow] = props.showState

    const t = useCallback(
        (text: TTranslationKey) => {
            if (langCode === ELanguage.VI) {
                return translations[text] ?? text
            }
            return text
        },
        [langCode]
    )

    return (
        <Popup
            isShow={isShow}
            lang={langCode}
            styleOption={{
                size: 'md',
                headerBg: 'linear-gradient(269deg, #B900F6 0.91%, #DC1EAF 23.38%, #FF6200 45.85%, #FDB92E 92.62%)',
                headerTextColor: '#fff',
                isHaveBorder: false,
                closeIconColor: '#fff'
            }}
            custom={{
                footer: (
                    <CTAWrapper>
                        <Row gutter={[0, 8]} justify='end'>
                            <Col xs='auto'>
                                <Button type='ai' outline='outline' onClick={() => onViewAnalysis && onViewAnalysis()}>
                                    {t('View analysis to maximize now')}
                                </Button>
                            </Col>
                            <Col xs='auto'>
                                <ButtonAI onClick={() => onContinueApply && onContinueApply()}>
                                    {t('Continue applying')}
                                </ButtonAI>
                            </Col>
                        </Row>
                    </CTAWrapper>
                )
            }}
            text={{
                header: t('Do you want to maximize competitive advantage before applying?')
            }}
            onClickOutside={() => setIsShow(false)}
            onClose={() => onContinueApply && onContinueApply()}
        >
            <AIBeforeApplyContainer>
                <ImageWrapper>
                    <img
                        src={`${imageUrl}/images/AI-review-before-apply.png`}
                        alt={t('Maximize your competitive advantage with VietnamWorks AI before applying')}
                    />
                </ImageWrapper>
                <ListWrapper>
                    <Typography name='body' size='large' style={{ marginBottom: '16px' }}>
                        {t('Maximize your competitive advantage with VietnamWorks AI before applying')}
                    </Typography>
                    <ul className='list'>
                        <li>
                            <StarBurstIcon />{' '}
                            <Typography name='body' size='large'>
                                {t("Assess matching rate from employer's viewpoint")}
                            </Typography>
                        </li>
                        <li>
                            <StarBurstIcon />{' '}
                            <Typography name='body' size='large'>
                                {t('Suggest to improve the matching')}
                            </Typography>
                        </li>
                        <li>
                            <StarBurstIcon />{' '}
                            <Typography name='body' size='large'>
                                {t('Analyze the profiles of applicants')}
                            </Typography>
                        </li>
                        <li>
                            <StarBurstIcon />{' '}
                            <Typography name='body' size='large'>
                                {t('Check salary reference and hiring demand')}
                            </Typography>
                        </li>
                    </ul>
                    <AIBeforeApplyTypo size='large' name='body'>
                        {t('Explore the')} <span>{t('Competitive analysis report')}</span>{' '}
                        {t('now to get closer to your dream job!')}
                    </AIBeforeApplyTypo>
                </ListWrapper>
            </AIBeforeApplyContainer>
        </Popup>
    )
}

export default AIBeforeApply
